import { RawStudyMetaConfigV1 } from '@csp/config-schemas';
import { Maybe, StudyMetaConfig } from '@csp/csp-common-model';
import { StudyMetaValidationService } from './StudyMetaConfigValidationService';

const toStudyMetaConfig = (config?: RawStudyMetaConfigV1): Maybe<StudyMetaConfig> => {
  if (!config) {
    return undefined;
  }

  const studyMeta: Maybe<StudyMetaConfig> = StudyMetaValidationService.validateStudyMetaConfig(config);

  return studyMeta;
};

export const StudyMetaService = {
  toStudyMetaConfig,
};
